import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./PointsUntilNextLevel.module.scss";

export interface IPointsUntilNextLevelProps {
  pointsToLevel: number;
}

export const PointsUntilNextLevel: VoidFunctionComponent<IPointsUntilNextLevelProps> = ({pointsToLevel}) => {
  return <div className={s.pointsUntilNextLevel}>
    <dt>Points until next&nbsp;level</dt>
    <dd>{pointsToLevel}</dd>
  </div>;
}

